import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogActions, Button } from "@material-ui/core";
import { DateRangePicker } from "react-date-range";

/**
 * Reusable DateRangePicker dialog component
 */
export const DateRangePickerDialog = ({
  open,
  onClose,
  selectionRange,
  onChange,
  staticRanges,
  retainEndDateOnFirstSelection = false,
}) => {
  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogContent>
        <DateRangePicker
          retainEndDateOnFirstSelection={retainEndDateOnFirstSelection}
          ranges={[selectionRange]}
          inputRanges={staticRanges ? [] : undefined}
          staticRanges={staticRanges}
          onChange={onChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DateRangePickerDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectionRange: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  staticRanges: PropTypes.array,
  retainEndDateOnFirstSelection: PropTypes.bool,
};

